import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import TransfersPage, { getDefaultPageUI } from "components/pages/TransfersPage";
import Classes from "model";
import React, { useEffect } from "react";

/**
 * @name CaptureUnlinkedAccountsAccountDDOpen
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "Unlinked Accounts" (abi22).
 */
export default function CaptureUnlinkedAccountsAccountDDOpen(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI(undefined, context))
    .update([ "from" ], { isActive: true })
    .submit();

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

    return <TransfersPage ui={ ui } />;
}